import { navigateTo } from 'helpers/url';
import { AngleRightIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import classes from './MobileAlgoResources.module.scss';
import type { FeatureCardProps } from './types';

const FeatureCard = ({ label, description, icon, link, target }: FeatureCardProps) => {
  return (
    <Box
      data-testid={`algo-resources-feature-card-${label}`}
      className={classes.featureCard}
      onClick={() => navigateTo(link, target)}
    >
      <Box className={classes.iconBox}>{icon}</Box>
      <Box className={classes.textWrapper}>
        <Box className={classes.title}>{label}</Box>
        <Box className={classes.description}>{description}</Box>
      </Box>
      <Box className={classes.arrowIcon}>
        <Box data-testid={`${label}-card-arrow`}>
          <AngleRightIcon />
        </Box>
      </Box>
    </Box>
  );
};

export { FeatureCard };
